var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vue-root" }, [
    _c(
      "div",
      {
        staticClass: "form_success bg-success",
        class: { "d-none": this.sentSuccessfull !== true },
      },
      [_vm._v("\n        " + _vm._s(_vm.t("register.success")) + "\n    ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "form webform row",
        class: { "d-none": this.sentSuccessfull === true },
      },
      [
        _c(
          "div",
          {
            staticClass: "form-item text field-float",
            class: { "is-invalid": _vm.errorData.user_company },
            attrs: { "general-errors": "" },
          },
          [
            _c("div", { staticClass: "input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.user_company,
                    expression: "formData.user_company",
                  },
                ],
                attrs: {
                  id: "register_firma",
                  name: "register_firma",
                  placeholder: _vm.t("register.company"),
                  type: "text",
                },
                domProps: { value: _vm.formData.user_company },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "user_company", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "register_firma" } }, [
                _c("span", { staticClass: "origin" }, [
                  _vm._v(_vm._s(_vm.t("register.company"))),
                  _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _vm.errorData.company
                  ? _c("span", { staticClass: "error" })
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.scenario === "partner"
          ? _c(
              "div",
              {
                staticClass: "form-item text field-float",
                class: {
                  "is-invalid": _vm.errorDataPartner.user_debitorennummer,
                },
                attrs: { "general-errors": "" },
              },
              [
                _c("div", { staticClass: "input-wrapper" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.user_debitorennummer,
                        expression: "formData.user_debitorennummer",
                      },
                    ],
                    attrs: {
                      id: "register_debitorennummer",
                      name: "user_debitorennummer",
                      placeholder: _vm.t("register.debitorennumber"),
                      type: "text",
                    },
                    domProps: { value: _vm.formData.user_debitorennummer },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.formData,
                          "user_debitorennummer",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "register_debitorennummer" } }, [
                    _c("span", { staticClass: "origin" }, [
                      _vm._v(_vm._s(_vm.t("register.debitorennumber"))),
                      _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
                    ]),
                    _vm._v(" "),
                    _vm.errorDataPartner.user_debitorennummer
                      ? _c("span", { staticClass: "error" })
                      : _vm._e(),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "form-item radio form-check custom--selection form-check-inline",
            attrs: { "general-errors": "" },
          },
          [
            _c("div", { staticClass: "radio-container radio-row" }, [
              _c("div", { staticClass: "radio-item" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.salutation,
                      expression: "formData.salutation",
                    },
                  ],
                  attrs: {
                    type: "radio",
                    id: "register_salutation_m",
                    name: "register_salutation",
                    value: "m",
                  },
                  domProps: { checked: _vm._q(_vm.formData.salutation, "m") },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.formData, "salutation", "m")
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "register_salutation_m" } }, [
                  _vm._v(" " + _vm._s(_vm.t("register.man")) + " "),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "radio-item" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.salutation,
                      expression: "formData.salutation",
                    },
                  ],
                  attrs: {
                    type: "radio",
                    id: "register_salutation_f",
                    name: "register_salutation",
                    value: "f",
                  },
                  domProps: { checked: _vm._q(_vm.formData.salutation, "f") },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.formData, "salutation", "f")
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "register_salutation_f" } }, [
                  _vm._v(" " + _vm._s(_vm.t("register.woman")) + " "),
                ]),
              ]),
              _vm._v(" "),
              _vm.errorData.salutation
                ? _c("span", { staticClass: "error-text" }, [
                    _vm._v(_vm._s(_vm.t("register.required"))),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-item text field-float col-50",
            class: { "is-invalid": _vm.errorData.firstname },
            attrs: { "general-errors": "" },
          },
          [
            _c("div", { staticClass: "input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.firstname,
                    expression: "formData.firstname",
                  },
                ],
                attrs: {
                  id: "register_firstname",
                  name: "register_firstname",
                  placeholder: _vm.t("register.firstname"),
                  type: "text",
                },
                domProps: { value: _vm.formData.firstname },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "firstname", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "register_firstname" } }, [
                _c("span", { staticClass: "origin" }, [
                  _vm._v(_vm._s(_vm.t("register.firstname"))),
                  _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _vm.errorData.firstname
                  ? _c("span", { staticClass: "error" })
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-item text field-float col-50",
            class: { "is-invalid": _vm.errorData.lastname },
            attrs: { "general-errors": "" },
          },
          [
            _c("div", { staticClass: "input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.lastname,
                    expression: "formData.lastname",
                  },
                ],
                attrs: {
                  id: "register_lastname",
                  name: "register_lastname",
                  placeholder: _vm.t("register.lastname"),
                  type: "text",
                },
                domProps: { value: _vm.formData.lastname },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "lastname", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "register_lastname" } }, [
                _c("span", { staticClass: "origin" }, [
                  _vm._v(_vm._s(_vm.t("register.lastname"))),
                  _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _vm.errorData.lastname
                  ? _c("span", { staticClass: "error" })
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-item text field-float col-100",
            class: { "is-invalid": _vm.errorDataArchitect.address },
            attrs: { "general-errors": "" },
          },
          [
            _c("div", { staticClass: "input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.address,
                    expression: "formData.address",
                  },
                ],
                attrs: {
                  id: "register_address",
                  name: "address",
                  placeholder: _vm.t("register.address"),
                  type: "text",
                },
                domProps: { value: _vm.formData.address },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "address", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "register_address" } }, [
                _c("span", { staticClass: "origin" }, [
                  _vm._v(_vm._s(_vm.t("register.address"))),
                  _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _vm.errorDataArchitect.address
                  ? _c("span", { staticClass: "error" })
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.scenario === "architect"
          ? _c(
              "div",
              {
                staticClass: "form-item text field-float col-50",
                class: { "is-invalid": _vm.errorData.address_additional },
                attrs: { "general-errors": "" },
              },
              [
                _c("div", { staticClass: "input-wrapper" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.address_additional,
                        expression: "formData.address_additional",
                      },
                    ],
                    attrs: {
                      id: "register_address_additional",
                      name: "address_additional",
                      placeholder: _vm.t("register.address_additional"),
                      type: "text",
                    },
                    domProps: { value: _vm.formData.address_additional },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.formData,
                          "address_additional",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { attrs: { for: "register_address_additional" } },
                    [
                      _c("span", { staticClass: "origin" }, [
                        _vm._v(_vm._s(_vm.t("register.address_additional"))),
                        _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
                      ]),
                      _vm._v(" "),
                      _vm.errorData.address_additional
                        ? _c("span", { staticClass: "error" })
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-item text field-float col-50",
            class: { "is-invalid": _vm.errorDataArchitect.zip },
            attrs: { "general-errors": "" },
          },
          [
            _c("div", { staticClass: "input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.zip,
                    expression: "formData.zip",
                  },
                ],
                attrs: {
                  id: "register_zip",
                  name: "zip",
                  placeholder: _vm.t("register.zip"),
                  type: "text",
                },
                domProps: { value: _vm.formData.zip },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "zip", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "register_zip" } }, [
                _c("span", { staticClass: "origin" }, [
                  _vm._v(_vm._s(_vm.t("register.zip"))),
                  _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _vm.errorDataArchitect.zip
                  ? _c("span", { staticClass: "error" })
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-item text field-float col-50",
            class: { "is-invalid": _vm.errorDataArchitect.location },
            attrs: { "general-errors": "" },
          },
          [
            _c("div", { staticClass: "input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.location,
                    expression: "formData.location",
                  },
                ],
                attrs: {
                  id: "register_location",
                  name: "location",
                  placeholder: _vm.t("register.location"),
                  type: "text",
                },
                domProps: { value: _vm.formData.location },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "location", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "register_location" } }, [
                _c("span", { staticClass: "origin" }, [
                  _vm._v(_vm._s(_vm.t("register.location"))),
                  _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _vm.errorDataArchitect.location
                  ? _c("span", { staticClass: "error" })
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-item country field-float",
            class: { "is-invalid": _vm.errorDataArchitect.country },
            attrs: { "general-errors": "" },
          },
          [
            _c(
              "div",
              {
                staticClass: "form-item select field-float",
                class: { "is-invalid": _vm.errorDataArchitect.country },
                attrs: { "general-errors": "" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "select__wrapper",
                    class: { "float-label": this.showOptionsCountryOpen },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "select",
                        attrs: { type: "button" },
                        on: { click: _vm.toggleCountryOptions },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            " " + _vm._s(this.selectedOptionCountryLabelLabel)
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.showOptionsCountry
                      ? _c("div", { staticClass: "select__options" }, [
                          _c(
                            "ul",
                            [
                              _vm._l(_vm.countries, function (country) {
                                return [
                                  _c(
                                    "li",
                                    {
                                      attrs: {
                                        "data-id": country.value,
                                        "data-label": country.label,
                                      },
                                      on: { click: _vm.setOptionCountry },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(country.label) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                ]
                              }),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("i", { staticClass: "icon-form-arrow" }),
                  ]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "register_firmtype" } }, [
                  _c("span", { staticClass: "origin" }, [
                    _vm._v(_vm._s(_vm.t("register.country"))),
                    _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
                  ]),
                ]),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "hidden", name: "user_companytype" },
                }),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _vm.scenario === "partner"
          ? _c(
              "div",
              {
                staticClass: "form-item text field-float col-50",
                class: { "is-invalid": _vm.errorData.user_abteilung },
                attrs: { "general-errors": "" },
              },
              [
                _c("div", { staticClass: "input-wrapper" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.user_abteilung,
                        expression: "formData.user_abteilung",
                      },
                    ],
                    attrs: {
                      id: "user_abteilung",
                      name: "register_user_abteilung",
                      placeholder: _vm.t("register.user_abteilung"),
                      type: "text",
                    },
                    domProps: { value: _vm.formData.user_abteilung },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.formData,
                          "user_abteilung",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "user_abteilung" } }, [
                    _c("span", { staticClass: "origin" }, [
                      _vm._v(_vm._s(_vm.t("register.user_abteilung"))),
                    ]),
                    _vm._v(" "),
                    _vm.errorData.user_abteilung
                      ? _c("span", { staticClass: "error" })
                      : _vm._e(),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-item text field-float",
            class: {
              "is-invalid": _vm.errorData.phone,
              "col-50": _vm.scenario === "partner",
            },
            attrs: { "general-errors": "" },
          },
          [
            _c("div", { staticClass: "input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.phone,
                    expression: "formData.phone",
                  },
                ],
                attrs: {
                  id: "register_phone",
                  name: "register_phone",
                  placeholder: _vm.t("register.phone"),
                  type: "text",
                },
                domProps: { value: _vm.formData.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "phone", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "register_phone" } }, [
                _c("span", { staticClass: "origin" }, [
                  _vm._v(_vm._s(_vm.t("register.phone"))),
                  _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _vm.errorData.phone
                  ? _c("span", { staticClass: "error" })
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-item email field-float",
            class: { "is-invalid": _vm.errorData.email },
            attrs: { "general-errors": "" },
          },
          [
            _c("div", { staticClass: "input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.email,
                    expression: "formData.email",
                  },
                ],
                attrs: {
                  id: "register_email",
                  name: "register_email",
                  placeholder: _vm.t("register.email"),
                  type: "email",
                },
                domProps: { value: _vm.formData.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "email", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "register_email" } }, [
                _c("span", { staticClass: "origin" }, [
                  _vm._v(_vm._s(_vm.t("register.email"))),
                  _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _vm.errorData.email
                  ? _c("span", { staticClass: "error" })
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-item password field-float",
            class: { "is-invalid": _vm.errorData.password },
            attrs: { "general-errors": "" },
          },
          [
            _c("div", { staticClass: "input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.password,
                    expression: "formData.password",
                  },
                ],
                attrs: {
                  id: "password",
                  name: "register_password",
                  placeholder: _vm.t("register.password"),
                  type: "password",
                },
                domProps: { value: _vm.formData.password },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "password", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "password" } }, [
                _c("span", { staticClass: "origin" }, [
                  _vm._v(_vm._s(_vm.t("register.password"))),
                  _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _vm.errorData.password
                  ? _c("span", { staticClass: "error" })
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-item password_repeat field-float",
            class: { "is-invalid": _vm.errorData.password_repeat },
            attrs: { "general-errors": "" },
          },
          [
            _c("div", { staticClass: "input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.password_repeat,
                    expression: "formData.password_repeat",
                  },
                ],
                attrs: {
                  id: "password_repeat",
                  name: "password_repeat",
                  placeholder: _vm.t("register.password_repeat"),
                  type: "password",
                },
                domProps: { value: _vm.formData.password_repeat },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.formData,
                      "password_repeat",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "password_repeat" } }, [
                _c("span", { staticClass: "origin" }, [
                  _vm._v(_vm._s(_vm.t("register.password_repeat"))),
                  _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _vm.errorData.password_repeat
                  ? _c("span", { staticClass: "error" })
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-item agb",
            class: { "is-invalid": _vm.errorData.ads_agb },
            attrs: { "general-errors": "" },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "form-item form-check custom--selection form-check-inline",
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.ads_agb,
                      expression: "formData.ads_agb",
                    },
                  ],
                  attrs: {
                    id: "register_ads_agb",
                    name: "register_ads_agb",
                    placeholder: _vm.t("register.ads_agb"),
                    type: "checkbox",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.formData.ads_agb)
                      ? _vm._i(_vm.formData.ads_agb, null) > -1
                      : _vm.formData.ads_agb,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.formData.ads_agb,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.formData, "ads_agb", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.formData,
                              "ads_agb",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.formData, "ads_agb", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "register_ads_agb" } }, [
                  _c("span", { staticClass: "origin" }, [
                    _vm._v(_vm._s(_vm.t("register.ads_agb"))),
                    _c("span", { staticClass: "mandatory" }, [_vm._v("*")]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.errorData.ads_agb
              ? _c("span", { staticClass: "error-text" }, [
                  _vm._v(_vm._s(_vm.t("register.required"))),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _vm.errorMessage != ""
          ? _c("div", [
              _c("span", { domProps: { innerHTML: _vm._s(_vm.errorMessage) } }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-item button ml-auto mr-0 mt-2",
            attrs: { "general-errors": "", values: "", "form-values": "" },
          },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "submit" },
                on: {
                  click: function ($event) {
                    return _vm.registerUser()
                  },
                },
              },
              [_c("span", [_vm._v(_vm._s(_vm.t("register.action")))])]
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _vm.sentSuccessfull
      ? _c("div", { staticClass: "pt-5" }, [
          _c("a", { attrs: { href: this.slug } }, [
            _c("button", { staticClass: "btn-primary" }, [
              _vm._v(_vm._s(_vm.t("register.gohome"))),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }